import React from 'react';
import { Row, Col } from 'reactstrap';
import _ from 'underscore';
import PropTypes from 'prop-types';
import SegmentedPicker from '../../common/controls/segmentedPicker';
import SinglePicker from '../../common/controls/singlePicker';
import TextInput from '../../common/controls/textInput';
import entityComposition from '../../common/classes/entityComposition';
class EmployeeGeneral extends React.Component {
  constructor(props) {
    super(props);
    const {
      onChange
    } = props;
    this.handleChange = (name, value) => onChange(name, value);
    this.handleChangeActive = this.handleChange.bind(null, 'active');
    this.handleChangePaygroupID = this.handleChange.bind(null, 'payGroupID');
    this.handleChangeCompCodeID = this.handleChange.bind(null, 'compCodeID');
    this.handleUserTypeChange = this.handleUserTypeChange.bind(this);
    this.userTypeChangePending = false;
  }
  componentDidMount() {
    const {
      groupAccessActions,
      groupAccess,
      payGroupActions,
      payGroup,
      compCodeActions,
      compCode
    } = this.props;
    groupAccessActions.serverIndex(groupAccess.indexQuery);
    payGroupActions.serverIndex(payGroup.indexQuery);
    compCodeActions.serverIndex(compCode.indexQuery);
  }
  handleUserTypeChange(value) {
    const {
      employee,
      groupAccess,
      notificationActions
    } = this.props;
    if (this.userTypeChangePending) {
      this.userTypeChangePending = false;
    } else {
      // Check if any jobs are assigned
      const nonEmployeeJobs = _.filter(employee.active.jobs, job => job.type !== 'Employee');
      if (!nonEmployeeJobs.length) {
        // No jobs are assigned, just change without confirming
        this.handleChange('groupAccessID', value);
        return;
      }

      // Grab the first non Employee assigned job title
      const {
        type
      } = nonEmployeeJobs[0];
      const message = type ? `Changing the user type from ${type} will remove the user from ${type} assignments on all jobs.` : '';
      notificationActions.info({
        headerMessage: 'Are you sure you want to change the user type?',
        message,
        leftButtonLabel: 'Change',
        leftButtonAction: () => {
          this.userTypeChangePending = true;
          this.handleChange('groupAccessID', value);
          const employeeJobs = _.filter(employee.active.jobs, job => job.type === 'Employee');
          this.handleChange('jobs', employeeJobs);

          // Save the user type, which helps the server save the job relationships
          const groups = groupAccess;
          const newUserType = groups.list.find(group => group.id === value);
          if (newUserType && newUserType.identifier) {
            this.handleChange('userType', newUserType.identifier);
          }
        },
        rightButtonLabel: 'Cancel',
        id: 'usertype_confirm' // the user should explicitly answer or dismiss
      }, {
        autoClose: false
      });
    }
  }
  render() {
    const {
      employee,
      groupAccess,
      payGroup,
      compCode
    } = this.props;
    const {
      active
    } = employee;
    return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", {
      className: "t-eg-section-general"
    }, "General"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: "First Name",
      field: "firstName",
      placeholder: "Required",
      entity: "Employee",
      onChange: this.handleChange,
      value: active.firstName
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: "Last Name",
      field: "lastName",
      placeholder: "Required",
      entity: "Employee",
      onChange: this.handleChange,
      value: active.lastName
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: "Email",
      field: "email",
      type: "email",
      entity: "Employee",
      onChange: this.handleChange,
      value: active.email
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "User Type",
      labelKey: "name",
      onChange: this.handleUserTypeChange,
      options: groupAccess.list,
      placeholder: "Select...",
      returnValueKey: "id",
      value: active.groupAccessID
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(SegmentedPicker, {
      names: ['Active', 'Inactive'],
      values: [1, 0],
      label: "Status",
      allowNull: false,
      onChange: this.handleChangeActive,
      value: active.active
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: "Employee Number",
      field: "employeeNumber",
      entity: "Employee",
      onChange: this.handleChange,
      value: active.employeeNumber
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "paygroup",
      labelKey: "name",
      onChange: this.handleChangePaygroupID,
      options: payGroup.list,
      placeholder: "Select...",
      returnValueKey: "id",
      value: active.payGroupID
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 12
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "comp code",
      labelKey: "name",
      onChange: this.handleChangeCompCodeID,
      options: compCode.list,
      placeholder: "Select...",
      returnValueKey: "id",
      value: active.compCodeID
    }))));
  }
}
EmployeeGeneral.propTypes = {
  employee: PropTypes.shape({
    active: PropTypes.shape({
      jobs: PropTypes.arrayOf(PropTypes.shape({})),
      compCodeID: PropTypes.string,
      payGroupID: PropTypes.string,
      active: PropTypes.number,
      groupAccessID: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
      employeeNumber: PropTypes.string
    }).isRequired
  }).isRequired,
  user: PropTypes.shape({
    groupAccessID: PropTypes.string,
    id: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  groupAccessActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  groupAccess: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    indexQuery: PropTypes.shape({})
  }).isRequired,
  payGroupActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  compCodeActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  compCode: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    indexQuery: PropTypes.shape({})
  }).isRequired,
  payGroup: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    indexQuery: PropTypes.shape({})
  }).isRequired,
  notificationActions: PropTypes.shape({
    info: PropTypes.func
  }).isRequired
};
export { EmployeeGeneral as TestEmployeeGeneral };
export default entityComposition(EmployeeGeneral, ['employee', 'payGroup', 'compCode', 'groupAccess'], {
  user: state => state.login.user
}, ['notification']);